import { createTV } from 'tailwind-variants';
import { borderRadiusClassesConfig, borderWidthClassesConfig } from './border';
import { fontSizeClassesConfig } from './fontSize';
/**
 * `tailwind-variant` caches the `twMergeConfig` in a global object that will be updated each time the `tv` method will be called with a `twMergeConfig`
 * This means that the last module that is loaded containing a `tv({}, { twMergeConfig: { ...something } })`
 * will override the twMergeConfig for every single components using tailwind-variant in the tree
 *
 * As a result
 * - `twMergeConfig` should NEVER be used !
 * - `customTV` should always be used in place of the default tv
 *
 * @link https://github.com/nextui-org/tailwind-variants/blob/9effc2ac029c79eae821bfa8acaf0cd873884575/src/index.js#L92
 */
export const customTV = createTV({
    twMergeConfig: {
        override: {
            classGroups: Object.assign(Object.assign(Object.assign({}, fontSizeClassesConfig), borderRadiusClassesConfig), borderWidthClassesConfig),
        },
        extend: {
            classGroups: {
                display: ['[display:inherit]'],
                'text-alignment': ['[text-align:inherit]'],
            },
        },
    },
});
const customEmptyTvInstance = customTV({});
/**
 * Merges a list of classNames according to tailwind-variant's internal merging rules.
 * The result is equivalent of a variant's `className` (or `class`) property, which is
 * similar to libraries like `classnames` or `clsx`
 *
 * @example
 * tvMerge(['text-lg', condition && 'mx-4', className])
 */
export const tvMerge = (className) => customEmptyTvInstance({ className });
